import { render, staticRenderFns } from "./RegionChoiceSection.vue?vue&type=template&id=7d82fab8&scoped=true&"
import script from "./RegionChoiceSection.vue?vue&type=script&lang=js&"
export * from "./RegionChoiceSection.vue?vue&type=script&lang=js&"
import style0 from "./RegionChoiceSection.vue?vue&type=style&index=0&id=7d82fab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d82fab8",
  null
  
)

export default component.exports